import { Circles } from "react-loader-spinner";

export default function FullPageLoader() {
  return (
    <div style={{
      position: "fixed", top: 0, left: 0,
      width: "100%", height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 9999,
      display: "flex", alignItems: "center", justifyContent: "center",
      color: "#fff", fontSize: "1.5rem", fontWeight: "bold"
    }}>
      <Circles color="#fff" height={80} width={80} />
    </div>
  );
}
